// Cambia únicamente este valor para alternar el ambiente: PRODUCTION | TRAINING | QA | DEV
export const NAME: string = 'PRODUCTION';

const isProd = NAME === 'PRODUCTION';
const isTraining = NAME === 'TRAINING';

// API / HOST
export const API_BASE_URL = isProd
  ? 'https://backabc.plan-roa.org'
  : isTraining
    ? 'https://trainingbackcomms.plan-roa.org'
    : 'https://qabackabc.plan-roa.org';

export const HOST_URL = isProd
  ? 'https://abc.plan-roa.org/'
  : isTraining
    ? 'https://trainingcomms.plan-roa.org'
    : 'https://qaabc.plan-roa.org/authorization-code/callback';

export const HOST_URL_LOGOUT = isProd
  ? 'https://abc.plan-roa.org/authorization-code'
  : isTraining
    ? 'https://trainingcomms.plan-roa.org/authorization-code'
    : 'https://qaabc.plan-roa.org/authorization-code';

export const CLOSE_SESSION = isProd
  ? 'https://plan-international.okta-emea.com/login/signout'
  : 'https://plan-international.oktapreview.com/oauth2/default/v1/logout';

// URL de login Okta (prod usa okta-emea, el resto usa oktapreview)
export const OKTA_LOGIN_URL = isProd
  ? 'https://plan-international.okta-emea.com/oauth2/v1/authorize?client_id=0oa9z2nfgch2nWFHN0i7&response_type=code&scope=openid&redirect_uri=https://abc.plan-roa.org/authorization-code/callback&state=HtOCo48cBhl9W5JLlL7pqnquPHDiyp9xYgP3y1rx'
  : `https://plan-international.oktapreview.com/oauth2/default/v1/authorize?client_id=0oa4m1spjdSdEazUl0x7&response_type=code&scope=openid&redirect_uri=${HOST_URL}&state=state-296bc9a0-a2a2-4a57-be1a-d0e2fd9bb601`;

export const AUTH_TOKEN = 'auth_token';
export const AUTH_SCOPES = 'scopes';
export const REFRESH_TOKEN = 'token_refresh';
export const USER_INFO = 'user';
export const APP_VERSION ='v5.0.2';
